<template>
  <div>
    <ez-autocomplete
      v-if="!hasSelectedVenue"
      ref="autocomplete"
      :source="venues"
      searchProperty="name"
      @selected="onVenueSelect"
      :label="`Search for a ${$t('global.venue')}`"
    >
      <template #result="{ result }">
        <v-venue-entity-info :venue="result" />
      </template>
    </ez-autocomplete>

    <ez-selected-venue
      v-else
      @remove="removeSelectedVenue"
      :venue="selectedVenue"
      only-basic-info
    />
  </div>
</template>

<script>
/**
 * SelectVenue
 * @version 1.0.0
 * @since 2.3.0
 */

import EzAutocomplete from '@/components/ui/Autocomplete';
import VVenueEntityInfo from '@/components/v3/patterns/VVenueEntityInfo';
import confirmation from '@/components/v3/patterns/VConfirmation/control';
import { EzSelectedVenue } from '@/components/ui/SelectedItem';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { wizardListenerMixin } from '@/mixins/wizard';

export default {
  mixins: [wizardListenerMixin],
  components: {
    EzAutocomplete,
    VVenueEntityInfo,
    EzSelectedVenue,
  },
  data() {
    return {
      venues: [],
    };
  },
  computed: {
    ...mapGetters('entities/orders', ['getDraftVenue', 'hasDraftProducts']),
    ...mapState('entities/orders', ['outletReferenceNumber']),
    ...mapGetters('defaultImages', ['getDefaultImage']),
    ...mapState('entities/users', ['contextId']),
    defaultImage() {
      return this.getDefaultImage('venue');
    },
    selectedVenue() {
      return this.getDraftVenue;
    },
    hasSelectedVenue() {
      return Object.keys(this.selectedVenue).length > 0;
    },
    venueId() {
      return this.contextId;
    },
  },
  methods: {
    ...mapMutations('entities/orders', [
      'CLEAR_DRAFT',
      'SET_DRAFT_VENUE',
      'CLEAR_DRAFT_VENUE',
      'SET_OUTLET_REFERENCE_NUMBER',
      'CLEAR_PRODUCTS',
      'CLEAR_SELECTED_PRODUCTS',
      'CLEAR_OUTLET_REFERENCE_NUMBER',
    ]),
    ...mapActions('entities/orders', ['fetchInventoryTransferDestinations']),
    async onVenueSelect(result) {
      const { selected } = result;

      this.SET_DRAFT_VENUE(selected);
      this.enableNextStep();
    },
    async removeSelectedVenue() {
      if (this.hasDraftProducts) {
        const { close, canceled } = await confirmation.alert({
          title: this.$t('orders.removeVenueOnAddNewOrderAlertTitle'),
          message: this.$t('orders.removeVenueOnAddNewOrderAlertMessage'),
        });
        if (canceled) return;
        close();
        this.CLEAR_DRAFT();
      }
      this.disableNextStep();
      this.CLEAR_DRAFT_VENUE();
      this.CLEAR_PRODUCTS();
      this.CLEAR_SELECTED_PRODUCTS();
    },
    async onNextStep() {
      this.SET_DRAFT_VENUE({ ...this.selectedVenue });
      this.$emit('stepCompleted');
    },
  },
  async mounted() {
    const { data } = await this.fetchInventoryTransferDestinations({ venueId: this.venueId });
    this.venues = data.data;
    if (this.hasSelectedVenue) {
      this.enableNextStep();
    }
  },
};
</script>

<style lang="scss" scoped></style>
